export const AUTONOMOUS_MARKETING_NS = "marketing-autonomous";
export const AUTONOMOUS_MARKETING_LOCALE_FILE = `${AUTONOMOUS_MARKETING_NS}.json`;

export function isAutonomousMarketingLaunched(
  advisory: string | undefined,
  execution: string | undefined,
  live: string | undefined,
): boolean {
  return advisory === "true" && execution === "true" && live === "true";
}

interface AutonomousAvailabilityTier {
  purchasable: boolean;
  limits: { agenticAutomationRunsPerDay: null };
  capabilities: { agenticBotExecution: boolean; agenticBotLive: boolean };
}

export function hasAutonomousProductAvailability(
  tiers: readonly AutonomousAvailabilityTier[] | undefined,
): boolean {
  return Boolean(
    tiers?.some(
      (tier) =>
        tier.purchasable &&
        tier.capabilities.agenticBotExecution &&
        tier.capabilities.agenticBotLive &&
        tier.limits.agenticAutomationRunsPerDay === null,
    ),
  );
}

export const AUTONOMOUS_MARKETING_ENABLED = isAutonomousMarketingLaunched(
  import.meta.env.VITE_AGENTIC_TRADING_ENABLED,
  import.meta.env.VITE_AGENTIC_BOT_EXECUTION_ENABLED,
  import.meta.env.VITE_AGENTIC_BOT_LIVE_ENABLED,
);
